import React from 'react';
import './ConnectionsView.css';

const ConnectionsView = ({
  connections,
  selectedConnection,
  onConnectionChange,
  onEdit,
  onDelete,
  onAddConnection,
}) => {
  if (connections.length === 0) {
    return (
      <div className="connections-view connections-view--empty">
        <div className="connections-empty-state">
          <p>No connections yet</p>
          <p className="connections-empty-hint">Add a connection to get started</p>
          <button type="button" className="btn-add-connection-large" onClick={onAddConnection}>
            + Add Connection
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="connections-view">
      <div className="connections-tabs">
        <div className="connections-tabs-list">
          {connections.map((conn) => (
            <div
              key={conn.id}
              className={`connections-tab ${selectedConnection?.id === conn.id ? 'active' : ''}`}
              onClick={() => onConnectionChange(conn)}
            >
              <span className="connections-tab-name">{conn.name}</span>
            </div>
          ))}
          <button
            type="button"
            className="btn-new-connection-tab"
            onClick={onAddConnection}
            title="Add connection"
          >
            +
          </button>
        </div>
      </div>

      <div className="connections-detail">
        {selectedConnection && (
          <>
            <div className="connections-detail-card">
              <div className="connections-detail-header">
                <h3>{selectedConnection.name}</h3>
                <div className="connections-detail-actions">
                  <button
                    type="button"
                    className="btn-edit-connection"
                    onClick={() => onEdit(selectedConnection)}
                    title="Edit connection"
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    className="btn-delete-connection"
                    onClick={() => {
                      if (window.confirm('Are you sure you want to delete this connection?')) {
                        onDelete(selectedConnection.id);
                      }
                    }}
                    title="Delete connection"
                  >
                    Delete
                  </button>
                </div>
              </div>

              <dl className="connections-detail-fields">
                <div className="connections-detail-row">
                  <dt>Name</dt>
                  <dd>{selectedConnection.name}</dd>
                </div>
                <div className="connections-detail-row">
                  <dt>Fusion/HCM URL</dt>
                  <dd>{selectedConnection.hcm_url || selectedConnection.connectionHost}</dd>
                </div>
                <div className="connections-detail-row">
                  <dt>Username</dt>
                  <dd>{selectedConnection.username || selectedConnection.connectionUser}</dd>
                </div>
                <div className="connections-detail-row">
                  <dt>Password</dt>
                  <dd className="connections-detail-masked">••••••••</dd>
                </div>
                <div className="connections-detail-row">
                  <dt>Authentication</dt>
                  <dd>{selectedConnection.auth_type === 'sso' ? 'Single Sign On' : 'Local'}</dd>
                </div>
              </dl>

              <p className="connections-detail-hint">
                Password is hidden for security. Use Edit to change connection details.
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ConnectionsView;
